import { AssetDetailsResponse } from '@ddt-web/common';

export interface PortfolioAssetDetailsResponse {
	requestId: string;
	accountId: string;
	accountName: string;
	holdings: AssetDetailsResponse[];
	partnerId?: string;
}

export function isPortfolioAssetDetailsResponse(object: any) {
	return 'partnerId' in object && 'accountId' in object;
}

export interface PortfolioHoldingsResolutionTableData extends PortfolioAssetDetailsResponse {
	totalHoldingsToResolveCount: number;
	resolvedHoldingsCount: number;
};

export interface ExistingExternalPortfolioMetaData {
	name: string;
	uniqueId: string;
} 
